
























































































































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { Endorsement, IEndorsementChange } from '@/modules/Policy/interfaces/endorsement'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { billingType, policyStatus } from '@/modules/Policy/helpers/policy'
import AppDialog from '@/components/AppDialog.vue'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    AppDialog
  }
})
export default class EndorsementDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: Object as () => Endorsement }) readonly endorsement!: Endorsement
  @Prop({ type: Object as () => IEndorsementChange }) readonly changeContent!: IEndorsementChange
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  policyInfo: IEndorsementChange = {}

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  billingType = billingType
  policyStatus = policyStatus
  dollarFilter = dollarFilter

  showFormDialog = false

  get title () {
    if (!this.endorsement) {
      return ''
    }
    return dateTimeToDisplay(this.endorsement.createdAt) + ' - Endorsement'
  }

  get recordTypeAdditions () {
    if (!this.recordType) return []

    return this.recordType.additionalInfo.slice(6)
  }

  get additionalInfo () {
    if (!this.endorsement) {
      return {}
    }

    return JSON.parse(this.endorsement.additionalInfoStr)
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    this.showFormDialog = val
  }

  emphasize (key: string) {
    if (!this.changeContent) {
      return ''
    }
    return this.changeContent[key]
      ? 'emphasize-color'
      : ''
  }

  parseEndorsementNote (note: string) {
    return note ? note.split('\n') : []
  }

  @Emit('cancel')
  onCancel () {
    // do nothing
  }
}
